<template>
  <article class="rounded px-6 py-12 rule-card fill-height d-flex flex-column">
    <div class="text-center text-h1 mb-6">
      <i :class="icon" />
    </div>
    <h3 class="text-center text-body mb-6">{{ title }}</h3>
    <div>
      <slot />
    </div>
  </article>
</template>

<script>
export default {
  props: {
    title: String,
    icon: String,
  },
}
</script>

<style scoped>
.rule-card {
  border: 1px solid var(--v-navy-lighten2);
  min-height: 280px;
}
</style>
